import { useSite } from "../context/SiteContext";

// Small SVG OF-style logomark (blue-teal roundel with the letters "OF").
function OfMark({ size = 22 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className="flex-shrink-0"
    >
      <circle cx="16" cy="16" r="16" fill="#00AFF0" />
      <text
        x="16"
        y="21"
        textAnchor="middle"
        fontSize="12"
        fontFamily="Manrope, sans-serif"
        fontWeight="800"
        fill="#ffffff"
        letterSpacing="0.5"
      >
        OF
      </text>
    </svg>
  );
}

/** Bold gold gradient card that pushes gallery visitors to OnlyFans. */
export default function GalleryOfCta({ variant = "public" }) {
  const { content } = useSite();
  const url =
    content.onlyfans_url ||
    content.onlyfans ||
    "https://onlyfans.com/camilla.xxx?rec=485728775";
  const handle = content.handle || "camilla.xxx";
  // column-span: all breaks the masonry CSS-column flow so the card is a
  // full-width band inside the gallery grid.
  const spanStyle = { columnSpan: "all", WebkitColumnSpan: "all" };

  if (variant === "vip") {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        style={spanStyle}
        className="of-cta of-cta--vip block rounded-xl p-5 md:p-6 border border-[rgba(201,169,97,0.35)] bg-gradient-to-br from-[#221816] to-[#12100f] hover:border-gold transition-colors mb-4"
        data-testid="gallery-of-cta-vip"
        onClick={() => { try { require("../lib/analytics").trackOf("gallery_vip_cta"); } catch {} }}
      >
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between">
          <div>
            <p className="text-[0.7rem] uppercase tracking-[0.2em] text-gold mb-2">
              Want even more?
            </p>
            <p className="font-serif italic text-xl md:text-2xl text-ivory leading-snug">
              This is just a taste.
            </p>
          </div>
          <span className="btn-gold shimmer-btn whitespace-nowrap inline-flex items-center gap-2 self-stretch sm:self-auto">
            <OfMark size={18} />
            Unlock everything on OnlyFans →
          </span>
        </div>
        <p className="text-[0.65rem] text-[color:var(--muted)] mt-3 tracking-wider">
          {handle}
        </p>
      </a>
    );
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={spanStyle}
      className="of-cta of-cta--hero block rounded-xl overflow-hidden border border-gold group focus:outline-none focus:ring-2 focus:ring-[color:var(--gold)] mb-4"
      data-testid="gallery-of-cta"
      onClick={() => { try { require("../lib/analytics").trackOf("gallery_public_cta"); } catch {} }}
    >
      <div className="of-cta-inner relative p-6 md:p-8 text-[#1a1208] bg-gradient-to-br from-[#e8ca80] via-[#d4b876] to-[#a88a48]">
        <p className="text-[0.7rem] md:text-[0.75rem] uppercase tracking-[0.24em] font-semibold mb-3 opacity-80">
          Liked what you saw? 💋
        </p>
        <h3 className="font-display text-3xl md:text-[2rem] leading-tight mb-3">
          See a <em className="not-italic underline decoration-[#1a1208]/40 underline-offset-4">lot</em> more on OnlyFans.
        </h3>
        <p className="text-sm md:text-[0.95rem] leading-relaxed mb-5 max-w-md opacity-90">
          Daily uncensored content, custom videos, sexting one-on-one, dick
          ratings, live streams — everything I can't post here.
        </p>
        <span className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-[#1a1208] text-[color:var(--gold-2)] font-semibold text-[0.78rem] uppercase tracking-wider shadow-[0_10px_30px_-10px_rgba(0,0,0,0.6)] shimmer-btn shimmer-btn--dark">
          <OfMark size={18} />
          Follow @{handle} 🔥
        </span>
        <div className="absolute right-3 bottom-3 text-[10px] tracking-widest uppercase opacity-60 hidden sm:block">
          onlyfans.com/{handle}
        </div>
      </div>
    </a>
  );
}
